import React from 'react';
import styles from './ModuleCard.module.css';

/** Estado vazio de um card de módulo: uma linha discreta com ícone e texto. */
const ModuleEmptyState = ({ icon, text }) => (
  <div className={styles.empty}>
    {icon && <span className={styles.emptyIcon}>{icon}</span>}
    <span>{text}</span>
  </div>
);

export default ModuleEmptyState;
